import {Route, Routes} from 'react-router-dom'
import {AuthLayout} from './AuthLayout'
import {Login} from './components/Login'
import { ResetPassword } from './components/ResetPassword'
import {ForgotPassword} from './components/ForgotPassword'
import { VerifyOTP } from './components/VerifyOTP'

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
    <Route path='login' element={<Login />} />
      <Route path='forgot-password' element={<ForgotPassword />} />
      <Route path='reset-password/:token' element={<ResetPassword />} />
      <Route path='verifyotp' element={<VerifyOTP />} />
      <Route index element={<Login />} />
    </Route>
  </Routes>
)

export {AuthPage}
